import React, { useEffect, useState } from 'react';
import { AlertTriangle, Check } from 'lucide-react';
import { SITE_AREAS } from '../site/areasContent';
import { ReadMore } from '../../portal/ui';

function Panel({ a, i }) {
  const Icon = a.icon;
  return (
    <div key={a.id} className="home-fade relative border border-[#262626] bg-[#0A0A0A] p-6 sm:p-8 lg:p-10 overflow-hidden" style={{ boxShadow: `0 0 60px -30px ${a.tone}` }} data-testid={`home-area-panel-${a.id}`}>
      <span className="absolute -right-24 -top-24 w-72 h-72 rounded-full opacity-10" style={{ background: a.tone }} />
      <div className="relative flex items-center gap-4 mb-6">
        <span className="w-14 h-14 grid place-items-center rounded-full" style={{ background: `${a.tone}1f`, color: a.tone }}><Icon size={26} /></span>
        <span className="font-mono text-xs uppercase tracking-[0.25em]" style={{ color: a.tone }}>Area 0{i + 1}</span>
      </div>
      <h3 className="relative font-heading font-bold text-2xl lg:text-3xl text-white mb-3">{a.claim}</h3>
      <ReadMore className="relative text-base text-[#A3A3A3] leading-relaxed mb-8 max-w-2xl" testid={`home-area-intro-${a.id}`}>{a.intro}</ReadMore>
      <div className="relative grid md:grid-cols-2 gap-6">
        <div>
          <p className="font-mono text-xs uppercase tracking-[0.2em] text-[#737373] mb-4">I rischi</p>
          <ul className="space-y-3">{a.risks.map((r) => <li key={r} className="flex gap-3 text-sm text-[#D4D4D4]"><AlertTriangle size={15} className="shrink-0 mt-0.5" style={{ color: a.tone }} />{r}</li>)}</ul>
        </div>
        <div>
          <p className="font-mono text-xs uppercase tracking-[0.2em] text-[#737373] mb-4">Cosa fa BOND</p>
          <ul className="space-y-3">{a.services.map((s) => <li key={s} className="flex gap-3 text-sm text-[#D4D4D4]"><Check size={15} className="shrink-0 mt-0.5 text-[#D4AF37]" />{s}</li>)}</ul>
        </div>
      </div>
    </div>
  );
}

export default function HomeAreas() {
  const [cur, setCur] = useState(0);
  useEffect(() => {
    const sync = () => { const i = SITE_AREAS.findIndex((a) => `#area-${a.id}` === window.location.hash); if (i >= 0) setCur(i); };
    sync();
    window.addEventListener('hashchange', sync);
    return () => window.removeEventListener('hashchange', sync);
  }, []);
  return (
    <section id="aree" className="relative py-28 bg-[#050505] border-t border-[#1F1F1F]" data-testid="home-areas">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
        <p className="font-mono text-xs uppercase tracking-[0.3em] text-[#D4AF37] mb-4">Le 4 aree di rischio</p>
        <h2 className="font-heading font-bold text-3xl sm:text-4xl lg:text-5xl text-white max-w-3xl mb-14">Quattro fronti, una sola piattaforma.</h2>
        <div className="grid lg:grid-cols-12 gap-6">
          <div className="lg:col-span-4 flex lg:flex-col gap-2 overflow-x-auto pb-2 lg:pb-0">
            {SITE_AREAS.map((a, i) => {
              const Icon = a.icon;
              const on = i === cur;
              return (
                <button key={a.id} id={`area-${a.id}`} onClick={() => setCur(i)} className={`shrink-0 text-left p-5 border transition-colors duration-300 flex items-center gap-4 scroll-mt-28 ${on ? 'bg-[#0D0D0D]' : 'border-[#1F1F1F] hover:border-[#333]'}`}
                  style={on ? { borderColor: a.tone } : undefined} data-testid={`home-area-tab-${a.id}`}>
                  <Icon size={20} style={{ color: on ? a.tone : '#737373' }} />
                  <span><span className="block font-mono text-[10px] text-[#525252]">0{i + 1}</span><span className={`block font-heading text-sm lg:text-base ${on ? 'text-white' : 'text-[#A3A3A3]'}`}>{a.title}</span></span>
                </button>
              );
            })}
          </div>
          <div className="lg:col-span-8"><Panel key={SITE_AREAS[cur].id} a={SITE_AREAS[cur]} i={cur} /></div>
        </div>
      </div>
    </section>
  );
}
